import React, { useState, useEffect } from 'react';

const CurrencyInput = ({ value = '', onChange, placeholder = '$0', className = '' }) => {
  const [displayValue, setDisplayValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    const sanitized = String(value || '').replace(/[^0-9-]/g, '');
    const negative = sanitized.startsWith('-');
    const digits = sanitized.replace(/[^0-9]/g, '');
    if (!digits) {
      setDisplayValue('');
      return;
    }
    const number = parseInt(digits, 10);
    const formatted = `${negative ? '-' : ''}${number.toLocaleString()}`;
    setDisplayValue(formatted);
  }, [value]);

  const formatCurrency = (input) => {
    const str = String(input || '');
    const negative = str.startsWith('-');
    const digits = str.replace(/[^0-9]/g, '');
    if (!digits) return negative ? '-' : '';
    const number = parseInt(digits, 10);
    return `${negative ? '-' : ''}${number.toLocaleString()}`;
  };

  const handleInputChange = (e) => {
    const input = e.target.value;
    const formatted = formatCurrency(input);
    setDisplayValue(formatted);
    onChange(formatted);
  };

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  return (
    <>
    <div className={`relative z-0 w-full max-w-4xl mx-auto ${className}`}>
      <div
        className={`relative overflow-hidden rounded-3xl border-4 bg-white transition-all duration-300 ${
          isFocused ? 'border-blue-500 shadow-lg shadow-blue-500/20' : 'border-gray-300 hover:border-gray-400'
        }`}
      >
        <input
          type="text"
          value={displayValue}
          onChange={handleInputChange}
          onKeyDown={(e) => { e.stopPropagation(); }}
          onKeyUp={(e) => { e.stopPropagation(); }}
          onKeyPress={(e) => { e.stopPropagation(); }}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          inputMode="numeric"
          pattern="[0-9-]*"
          autoComplete="off"
          enterKeyHint="done"
          className="currency-input-massive relative z-10 w-full px-6 py-4 sm:px-8 sm:py-6 md:px-10 md:py-8 lg:px-12 lg:py-10 font-bold text-center bg-transparent text-succession-text-primary placeholder-succession-text-secondary border-none outline-none transition-all duration-200"
        />

        {/* Focus background animation */}
        <div
          className={`absolute inset-0 z-0 pointer-events-none bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 transition-opacity duration-300 ${
            isFocused ? 'opacity-100' : 'opacity-0'
          }`}
        />
      </div>

      {/* Helper text */}
      <div className="mt-4 text-center">
        <p className="text-sm text-gray-500">Enter amount (e.g., 1000000 for $1,000,000)</p>
      </div>
    </div>
    {/* Strong size overrides with !important to avoid any global/tailwind conflicts */}
    <style>{`
      .currency-input-massive { font-size: clamp(2.25rem, 4vw, 3.75rem) !important; line-height: 1.1 !important; }
      @media (min-width: 768px) { .currency-input-massive { padding-top: 2rem !important; padding-bottom: 2rem !important; } }
      @media (min-width: 1024px) { .currency-input-massive { padding-top: 2.25rem !important; padding-bottom: 2.25rem !important; } }
    `}</style>
    </>
  );
};

export default CurrencyInput;


